import { render, staticRenderFns } from "./CommissionEdit.vue?vue&type=template&id=4db4a538"
import script from "./CommissionEdit.vue?vue&type=script&lang=js"
export * from "./CommissionEdit.vue?vue&type=script&lang=js"
import style0 from "./CommissionEdit.vue?vue&type=style&index=0&id=4db4a538&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports